import React, { useContext, useState } from 'react';
import { Card, Chip, Dialog, Grid, IconButton, Stack } from '@mui/material';
import './Meal.css';
import ReactDOM from 'react-dom';
import CookMeal from './Cook/CookMeal';
import Meal from '../../models/meal';
import DateComponent from '../UI/General/DateComponent';
import { Link } from 'react-router-dom';
import { PlaylistAdd, Restaurant } from '@mui/icons-material';
import MealsContext from '../../context/meals-context';
import StarRating from './StarRating';
import HealthRating from './HealthRating';
import PlanPicker from '../MealPlan/PlanPicker';

interface MealProps {
  meal: Meal;
}

const MealItem = (props: MealProps) => {
  const meal = props.meal;
  const [cookDialog, setCookDialog] = useState(false);
  const [planPickerOpen, setPlanPickerOpen] = useState(false);
  const mealImage = meal.imageThumbnail || meal.image || '/images/meal-placeholder.png';
  const mealsContext = useContext(MealsContext);

  const onCookDateSet = (date: Date) => {
    mealsContext.refresh();
    setCookDialog(false);
  };

  const handleClose = () => {
    setCookDialog(false);
  };

  if (cookDialog) {
    return ReactDOM.createPortal(
      <Dialog open={true}>
        <CookMeal mealName={meal.name} mealId={meal.id} onCookDateSet={onCookDateSet} onClose={handleClose} />
      </Dialog>,
      document.getElementById('primary') as HTMLElement
    );
  }

  const clickRecipe = () => {
    setCookDialog(true);
  };

  return (
    <>
      <Card>
        <Grid container spacing={0}>
          <Grid item xs={10}>
            <Link to={`/meal-detail/${meal.id}`}>
              <Stack direction="row" justifyContent="flex-start" alignItems="flex-start" spacing={2}>
                {<img alt={meal.name} className="meal-item__icon" src={mealImage} />}
                <Stack direction="column" spacing="2" alignItems="flex-start">
                  <div className="meal__name">{meal.name}</div>
                  {meal.tastiness !== null && <StarRating value={meal.tastiness} size="small" />}
                  {meal.healthiness !== null && <HealthRating value={meal.healthiness} size="small" />}
                  {meal.lastCooking !== null && (
                    <DateComponent className="meal" date={meal.lastCooking} title={'Naposledy:'} />
                  )}
                  {meal.lastCooking === null && <div className="meal__date">Ještě neuvařeno</div>}
                  {meal.tags.length > 0 && (
                    <Stack direction="row" spacing={0.5} flexWrap="wrap" sx={{ mt: 0.5 }}>
                      {meal.tags.map((tag) => (
                        <Chip
                          key={tag.id}
                          label={tag.name}
                          size="small"
                          variant="outlined"
                          sx={{ fontSize: '0.7rem', height: 20 }}
                        />
                      ))}
                    </Stack>
                  )}
                </Stack>
              </Stack>
            </Link>
          </Grid>
          <Grid item xs={2} paddingRight={1}>
            <Stack alignItems={'center'} justifyContent={'center'} height="100%" spacing={0}>
              <IconButton onClick={clickRecipe} color="primary" aria-label="Zaznamenat vaření" size="small">
                <Restaurant />
              </IconButton>
              <IconButton
                onClick={() => setPlanPickerOpen(true)}
                color="secondary"
                aria-label="Přidat do plánu"
                size="small"
              >
                <PlaylistAdd />
              </IconButton>
            </Stack>
          </Grid>
        </Grid>
      </Card>
      <PlanPicker mealId={meal.id} open={planPickerOpen} onClose={() => setPlanPickerOpen(false)} />
    </>
  );
};

export default MealItem;
